<ng-container *transloco="let t;">
    <form [formGroup]="filterForm" (ngSubmit)="applyFilter()" #form="ngForm">
        <div class="d-flex flex-column">
            <div class="custom-control mb-1 custom-radio">
                <input type="radio" id="{{item?.item?.meta_data_name + '_yes_filter'}}" formControlName="value"
                       [value]="true" class="custom-control-input"/>
                <label class="custom-control-label"
                       for="{{item?.item?.meta_data_name + '_yes_filter'}}">{{ t('Checkbox filter yes option (Advanced filters) - yes') }}</label>
            </div>
            <div class="custom-control mb-1 custom-radio">
                <input type="radio" id="{{item?.item?.meta_data_name + '_no_filter'}}" formControlName="value"
                        class="custom-control-input" [value]="false"/>
                <label class="custom-control-label"
                       for="{{item?.item?.meta_data_name + '_no_filter'}}">{{ t('Checkbox filter no option (Advanced filters) - no') }}</label>
            </div>
        </div>
        <div *ngIf="form.submitted && filterForm.invalid" class="invalid-feedback d-block">
            <div *ngIf="filterForm.controls['value'].hasError('required')">{{ t('Advanced filter required field validation (Advanced filters) - This field is required') }}</div>
        </div>

        <hr>
        <button type="submit" class="btn btn btn-primary btn-sm w-100">{{ t('Apply filter button name (Advanced filters) - Done') }}
        </button>
    </form>
</ng-container>